import styles from "./buttons.module.css";

const BorderedButton = ({
	text,
	onClick,
	className,
	disabled,
	type = "button",
	tooltip = "",
}) => {
	return (
		<button
			className={`${styles.borderedButton} ${className}`}
			onClick={onClick}
			type={type}
			disabled={disabled}
			title={tooltip}>
			{text}
		</button>
	);
};

export default BorderedButton;
